import { Component } from '@angular/core';

@Component({
  selector: 'app-add-icon',
  imports: [],
  templateUrl: './add-icon.html',
  styleUrl: './add-icon.scss'
})
export class AddIcon {

}
